import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: flex-start;
	padding-top: 8px;
	padding-bottom: 8px;
`;

export const notSetting = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	> p {
		font-size: 1.5rem;
	}
`;

export const imgRound = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;
	> img {
		width: 100%;
		min-height: 50px;
		background-color: ${color.interface.lightGray2};
		border-radius: 5px;
	}
`;

export const imgFull = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> img {
		width: 100%;
		min-height: 50px;
		background-color: ${color.interface.lightGray2};
	}
`;

export const dataNotSetting = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	> p {
		font-size: 1.5rem;
	}
`;

export const title = styled.h2`
	width: 90%;
	text-align: center;
	font-size: 1.5rem;
	font-weight: 900;
	color: ${color.interface.darkgray};
	padding: 0 8px;
`;

export const description = styled.p`
	width: 100%;
	padding: 0 8px;
	text-align: justify;
	font-size: 1.2rem;
	color: ${color.interface.darkgray};
`;

export const btn = styled.div`
	width: 95%;
	padding: 1.5rem;
	border-radius: 5px;
	text-align: center;
	font-weight: bold;
	color: ${color.interface.white};
	background-color: #4f2170;
`;
